import { config } from 'dotenv';
import { existsSync } from 'node:fs';
import { spawn } from 'node:child_process';
import { fileURLToPath } from 'node:url';
import { loadStoredKeysIntoEnv } from './utils/key-store.js';
import { runCli } from './cli.js';

// `max gateway [login|run]` delegates to the sibling gateway binary so users have
// one command surface. stdio is inherited so WhatsApp QR-code login works. In a
// dev checkout the built gateway.js isn't present — point the user at the script.
const argv = process.argv.slice(2);
if (argv[0] === 'gateway') {
  const gatewayEntry = fileURLToPath(new URL('./gateway.js', import.meta.url));
  if (existsSync(gatewayEntry)) {
    const child = spawn(process.execPath, [gatewayEntry, ...argv.slice(1)], { stdio: 'inherit' });
    child.on('exit', (code) => process.exit(code ?? 0));
    child.on('error', (err) => {
      console.error(`Failed to start gateway: ${err.message}`);
      process.exit(1);
    });
  } else {
    console.error('Gateway is available in the built CLI. From source, run "bun run gateway:login" then "bun run gateway".');
    process.exit(1);
  }
} else {
  // Load environment variables. Precedence: shell env > project .env > secure store.
  config({ quiet: true });
  loadStoredKeysIntoEnv();
  await runCli();
}
